var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/play-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.975 1.66663C5.375 1.66663 1.64166 5.39996 1.64166 9.99996C1.64166 14.6 5.375 18.3333 9.975 18.3333C14.575 18.3333 18.3083 14.6 18.3083 9.99996C18.3083 5.39996 14.5833 1.66663 9.975 1.66663ZM12.475 11.8583L10.0583 13.25C9.75833 13.425 9.425 13.5083 9.1 13.5083C8.76666 13.5083 8.44166 13.425 8.14166 13.25C7.54166 12.9 7.18333 12.2833 7.18333 11.5833V8.79163C7.18333 8.09996 7.54166 7.47496 8.14166 7.12496C8.74166 6.77496 9.45833 6.77496 10.0667 7.12496L12.4833 8.51663C13.0833 8.86663 13.4417 9.48329 13.4417 10.1833C13.4417 10.8833 13.0833 11.5083 12.475 11.8583Z",
    fill: "#6933FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.72bba38662bf8b50a996a25a082a16f6.svg";
export { ForwardRef as ReactComponent };